$(function () {
  const $window = $(window);
  const $header = $("#header");
  const $nav = $("#nav-header-menu");
  const $btnMenu = $(".btn-header-menu");

  // -----------------------------------------------------------
  // loading
  // -----------------------------------------------------------
  // (function () {
  //   $("#loading").addClass("is-shown").delay(5000).fadeOut();
  // })();
  (function () {
    const isTopPage = window.location.pathname === '/';
    const hasVisited = sessionStorage.getItem("visited");

    if (isTopPage && !hasVisited) {
      // トップページに初回アクセス
      sessionStorage.setItem("visited", "true");
      $("#loading").addClass("is-shown").delay(5000).fadeOut();
    } else {
      // トップページ以外、または2回目以降
      $("#loading").hide();
    }
  })();


  // -----------------------------------------------------------
  // ヘッダーナビの開閉
  // -----------------------------------------------------------
  (function () {
    const active = "is-active";
    $btnMenu.click(function () {
      $(this).toggleClass(active);
      $("body").toggleClass("nav-opend");
    });
    // ナビ内のリンクをクリック後、ナビを閉じる
    $nav.find("a").on("click", function () {
      $btnMenu.click();
    });

    // ハンバーガー内のメルマガフォーム送信後に #ContactHeader にリダイレクトされた場合、自動でハンバーガー開く
    $(document).ready(function () {
      const url = new URL(window.location.href);
      const hasCustomerPosted = url.searchParams.has("customer_posted");
      const isAtContactHeader = window.location.hash === "#ContactHeader";

      if (hasCustomerPosted && isAtContactHeader) {
        if (!$("body").hasClass("nav-opend")) {
          $btnMenu.click();
        }
        // スムーススクロールで #ContactHeader へ
        setTimeout(function () {
          const target = document.getElementById("ContactHeader");
          if (target) {
            target.scrollIntoView({ behavior: "smooth" });
          }
        }, 300);
      }
    });
  })();

  // -----------------------------------------------------------
  // スクロールに伴うヘッダーの変形及び、色の変更
  // -----------------------------------------------------------

  (function () {
    const scrolled = "is-scrolled";
    const headerWh = "header-wh";
    const headerBk = "header-bk";
    $window.scroll(function () {
      if ($(this).scrollTop() > 0) {
        $header.addClass(scrolled);
      } else {
        $header.removeClass(scrolled);
      }
    });
    // ヘッダーの文字色が白の場合
    if ($header.hasClass("header-wh")) {
      const $changeTarget = $(".js-change-header");
      if ($changeTarget.length) {
        const elmOffset = $changeTarget.offset().top;

        $window.scroll(function () {
          var scrollPos = $window.scrollTop();
          if (scrollPos > elmOffset) {
            $header.removeClass(headerWh);
            $header.addClass(headerBk);
          } else {
            $header.addClass(headerWh);
            $header.removeClass(headerBk);
          }
        });
      }
    }
  })();

  // -----------------------------------------------------------
  // アンカーリンクのスムーススクロール
  // -----------------------------------------------------------

  (function () {
    // ページ遷移を伴わないアンカーリンク
    $('a.js-scroll[href^="#"]').click(function () {
      const href = $(this).attr("href");
      const hash = href == "#" || href == "" ? "html" : href;
      scrollToAnker(hash);
      return false;
    });
    // ページ遷移を伴うアンカーリンク
    const urlHash = location.hash;
    if (urlHash) {
      $("body,html").stop().scrollTop(0);
      $window.on("load", function () {
        setTimeout(function () {
          scrollToAnker(urlHash);
        }, 400);
      });
    }
    // スムーススクロール
    function scrollToAnker(hash) {
      const target = $(hash);
      const position = target.offset().top;
      $("body,html").stop().animate(
        {
          scrollTop: position,
        },
        300
      );
    }
  })();

  // -----------------------------------------------------------
  // TOPスライダー
  // -----------------------------------------------------------

  (function () {
    var setSlider = setTimer();
    const active = "is-active";
    const before = "is-before";
    const $mvSlider = $("#mv-home-slider");
    const $mvSliderItem = $mvSlider.find(".mv-home-slider__item");
    const $counter__current = $(".mv-home-counter__current span");
    const $counter__total = $(".mv-home-counter__total");
    const total = $mvSliderItem.length;
    var current = 0;

    // スライドの切り替え
    function changeSlide(x, y) {
      $mvSliderItem.removeClass(before).eq(x).addClass(before);
      $mvSliderItem.removeClass(active).eq(y).addClass(active);
    }
    // スライド開始
    // スライドのカウント開始
    $counter__current.text("0" + 1);
    $counter__total.text("0" + total);
    // スライドのカウントを更新
    function checkCount() {
      $counter__current.text("0" + (current + 1));
    }
    // スライダーをループ
    function setTimer() {
      t = setInterval(function () {
        if (current < total - 1) {
          current++;
          checkCount();
          changeSlide(current - 1, current);
        } else {
          current = 0;
          checkCount();
          changeSlide(current - 1, current);
        }
      }, 5000);
      return t;
    }
  })();

  // -----------------------------------------------------------
  // 指定要素が画面内に入った時の処理
  // -----------------------------------------------------------

  (function () {
    $.fn.inView = function (options) {
      var elm = this;
      var defaults = {
        screenPos: 0.8,
        className: "is-inview",
      };
      var setting = $.extend(defaults, options);

      $window.on("load scroll", function () {
        inView();
      });

      function inView() {
        elm.each(function () {
          elmOffset = $(this).offset().top;
          scrollPos = $window.scrollTop();
          windowHeight = $window.height();
          if (scrollPos > elmOffset - windowHeight * setting.screenPos) {
            $(this).addClass(setting.className);
          }
        });
      }
    };
  })();

  $(".js-inview").inView({});
  $(".js-fade-in-up").inView({
    className: "fade-in-up",
  });

  // -----------------------------------------------------------
  // モーダル
  // -----------------------------------------------------------

  (function () {
    const show = "is-shown";
    var modal;
    var $path = window.location.pathname;
    // モーダルを開く
    $(".js-modal-open").each(function () {
      $(this).on("click", function () {
        var target = $(this).data("target");
        modal = document.getElementById(target);
        $(modal).fadeIn(400).addClass(show);
        // 動画がある場合は再生を開始
        if ($(modal).find("video").length) {
          const video = $(modal).find("video").get(0);
          video.play();
        }
        return false;
      });
    });
    // モーダルを閉じる
    $(".js-modal-close").on("click", function () {
      $(".js-modal").fadeOut(400).removeClass(show);
      // 動画がある場合は動画を停止
      if ($(modal).find("video").length) {
        const video = $(modal).find("video").get(0);
        video.pause();
      }
      return false;
    });
  })();

  // -----------------------------------------------------------
  // アコーディオン
  // -----------------------------------------------------------

  (function () {
    const active = "is-active";
    $(".js-accordion").click(function () {
      $(this).next(".js-accordion-body").stop(true, true).slideToggle(300);
      $(this).toggleClass(active);
    });
  })();

  // -----------------------------------------------------------
  // ドロップダウン
  // -----------------------------------------------------------

  (function () {
    $(".js-drop-down").click(function () {
      $(this).toggleClass("is-active");
    });
  })();

  // -----------------------------------------------------------
  // ブラウザ判定
  // -----------------------------------------------------------

  (function () {
    const ua = navigator.userAgent.toLowerCase();
    const ver = navigator.appVersion.toLowerCase();

    if (ua.indexOf("msie") != -1 || ua.indexOf("trident") != -1) {
      $("body").addClass("ie");
    } else if (ua.indexOf("edge") != -1) {
      $("body").addClass("edge");
    } else if (ua.indexOf("chrome") != -1) {
      $("body").addClass("chrome");
    } else if (ua.indexOf("safari") != -1) {
      $("body").addClass("safari");
    } else if (ua.indexOf("firefox") != -1) {
      $("body").addClass("firefox");
    } else {
    }
  })();

  // -----------------------------------------------------------
  // particles.js
  // -----------------------------------------------------------

  // PC時のパラメーター
  const paramPC = {
    particles: {
      number: {
        value: 280, //この数値を変更すると星の数が増減できる
        density: {
          enable: true,
          value_area: 3000, //星の密集度
        },
      },
      color: {
        value: "#d2a930",
      },
      shape: {
        type: "circle",
        stroke: {
          width: 0,
        },
      },
      opacity: {
        value: 1, //シェイプの透明度
        random: true, //シェイプの透明度をランダムにする
        anim: {
          enable: true, //シェイプの透明度をアニメーションさせる
          speed: 2, //シェイプの透明度をアニメーションさせる
          opacity_min: 0, //透明度の最小値０
          sync: false, //全てを同時にアニメーションさせない
        },
      },
      size: {
        value: 3.4,
        random: true,
        anim: {
          enable: false,
          speed: 4,
          size_min: 0.3,
          sync: false,
        },
      },
      line_linked: {
        enable: false,
      },
      move: {
        enable: true,
        speed: 120, //この数値を小さくするとゆっくりな動きになる
        direction: "none", //方向指定なし
        random: true, //動きはランダムに
        straight: true, //動きをとどめる
        out_mode: "out",
        bounce: false,
        attract: {
          enable: false,
          rotateX: 600,
          rotateY: 600,
        },
      },
    },
    interactivity: {
      detect_on: "canvas",
      events: {
        onhover: {
          enable: false,
        },
        onclick: {
          enable: false,
        },
        resize: true,
      },
    },
    retina_detect: true,
  };

  // SP時のパラメーター
  const paramSP = {
    particles: {
      number: {
        value: 300, //この数値を変更すると星の数が増減できる
        density: {
          enable: true,
          value_area: 1500, //星の密集度
        },
      },
      color: {
        value: "#d2a930",
      },
      shape: {
        type: "circle",
        stroke: {
          width: 0,
        },
      },
      opacity: {
        value: 1, //シェイプの透明度
        random: true, //シェイプの透明度をランダムにする
        anim: {
          enable: true, //シェイプの透明度をアニメーションさせる
          speed: 2, //シェイプの透明度をアニメーションさせる
          opacity_min: 0, //透明度の最小値０
          sync: false, //全てを同時にアニメーションさせない
        },
      },
      size: {
        value: 1.5,
        random: true,
        anim: {
          enable: false,
          speed: 4,
          size_min: 0.3,
          sync: false,
        },
      },
      line_linked: {
        enable: false,
      },
      move: {
        enable: true,
        speed: 120, //この数値を小さくするとゆっくりな動きになる
        direction: "none", //方向指定なし
        random: true, //動きはランダムに
        straight: true, //動きをとどめる
        out_mode: "out",
        bounce: false,
        attract: {
          enable: false,
          rotateX: 600,
          rotateY: 600,
        },
      },
    },
    interactivity: {
      detect_on: "canvas",
      events: {
        onhover: {
          enable: false,
        },
        onclick: {
          enable: false,
        },
        resize: true,
      },
    },
    retina_detect: true,
  };

  if ($("#js-particles").length) {
    windowWidth = window.innerWidth;
    if (windowWidth <= 576) {
      particlesJS("js-particles", paramSP);
    } else {
      particlesJS("js-particles", paramPC);
    }
  }
});

//squadbeyond_uidをlocalStorageに保存
(function () {
  try {
    var params = new URLSearchParams(window.location.search);
    var uid = params.get('squadbeyond_uid');
    if (!uid) return;

    localStorage.setItem('sb_squadbeyond_uid', uid);
    localStorage.setItem('sb_squadbeyond_uid_saved_at', String(Date.now()));
  } catch (e) {}
})();

// コレクションページ カラバリスライダー
document.addEventListener("DOMContentLoaded", function () {
  const sliderSets = document.querySelectorAll(".main-carousel");

  sliderSets.forEach(function (mainCarousel) {
    const parent = mainCarousel.closest(".js-silk-color-options") || document;
    const thumbnailCarousel = parent.querySelector(".thumbnail-carousel");

    const main = new Splide(mainCarousel, {
      type: "fade",
      rewind: true,
      pagination: false,
      arrows: true,
    });

    const thumbnails = new Splide(thumbnailCarousel, {
      fixedWidth: 100,
      gap: 10,
      isNavigation: true,
      pagination: false,
      arrows: false,
      drag: false,
      focus: false,
    });

    main.sync(thumbnails);
    main.mount();
    thumbnails.mount();
  });
});
